import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authService.tryEnsureAuthenticated().pipe(
            map((allowed) => {
                if (allowed) {
                    return true;
                }

                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }),
        );
    }
}
